// extracted by mini-css-extract-plugin
export default {"section":"AccordionFilter_section__56o--","header":"AccordionFilter_header__OVY-m","content":"AccordionFilter_content__Oi4Tr","flex":"AccordionFilter_flex__kyVSW"};